import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pathfinder-website/pathfinder-website/app/components/ChangelogPaginated.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pathfinder-website/pathfinder-website/app/components/DocsSidebar.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pathfinder-website/pathfinder-website/node_modules/next/dist/client/app-dir/link.js");
